export const CHART_TITLE_OFFSET = -20;
export const GRID_VERTICAL_MARGIN = 30;
export const BRUSH_HEIGHT = 60;
export const X_AXIS_FONT_SIZE = 12;
export const RIGHT_SIDE_OFFSET = 20; // number of data points at the right side of the right most candlestick
export const LEFT_SIDE_OFFSET = 20; // number of data points at the left side of the right most candlestick
export const INIT_CHART_HEIGHT = 6; // this makes the top y-axis tick label wholely visible

export const DESKTOP_PRICE_CHART_HEIGHT = 500;
export const MOBILE_PRICE_CHART_HEIGHT = 250;
export const DEFAULT_SERIES_HEIGHT = 80;
export const MIN_DESKTOP_PRICE_CHART_HEIGHT = 340;
export const MIN_MOBILE_PRICE_CHART_HEIGHT = 170;

/**
 * The minimal window size user can zoom in
 */
export const MIN_VALUE_SPAN = 25;

/**
 * SVG zoom icon for the toolbox in mychart
 */
export const ZOOM_IN_BUTTON_ICON =
  'path://M11.5 0c6.347 0 11.5 5.153 11.5 11.5s-5.153 11.5-11.5 11.5-11.5-5.153-11.5-11.5 5.153-11.5 11.5-11.5zm0 1c5.795 0 10.5 4.705 10.5 10.5s-4.705 10.5-10.5 10.5-10.5-4.705-10.5-10.5 4.705-10.5 10.5-10.5zm.5 10h6v1h-6v6h-1v-6h-6v-1h6v-6h1v6z';
export const ZOOM_OUT_BUTTON_ICON =
  'path://M11.5 0c6.347 0 11.5 5.153 11.5 11.5s-5.153 11.5-11.5 11.5-11.5-5.153-11.5-11.5 5.153-11.5 11.5-11.5zm0 1c5.795 0 10.5 4.705 10.5 10.5s-4.705 10.5-10.5 10.5-10.5-4.705-10.5-10.5 4.705-10.5 10.5-10.5zm-6.5 10h13v1h-13v-1z';
export const ZOOM_RESTORE_BUTTON_ICON =
  'path://M12 0c-3.31 0-6.291 1.353-8.459 3.522l-2.48-2.48-1.061 7.341 7.437-.966-2.489-2.488c1.808-1.808 4.299-2.929 7.052-2.929 5.514 0 10 4.486 10 10s-4.486 10-10 10c-3.872 0-7.229-2.216-8.89-5.443l-1.717 1.046c2.012 3.803 6.005 6.397 10.607 6.397 6.627 0 12-5.373 12-12s-5.373-12-12-12z';
